// components
import {
  styled,
  Box,
  BoxProps,
  PaletteColor,
  ListItem,
  ListItemProps
} from '@mui/material';

// types
import type { MuiTheme } from '@sdb/planning-ui/ui-3/packages/types/src/theme/sx.types';

type PaletteKey = keyof MuiTheme['palette'];
type IconColor = PaletteKey | string;
interface IconContainerProps extends Omit<BoxProps, 'color'> {
  color?: IconColor;
  noBackground?: boolean;
}

export const StyledFlexMatchContainer = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(6, 4)
}));

export const StyledIconContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color'
})<IconContainerProps>(({ theme, color = 'primary', noBackground }) => {
  const maybePalette = theme.palette[color as PaletteKey] as
    | PaletteColor
    | undefined;
  const resolved = maybePalette ? maybePalette.main : (color as string);

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    color: resolved,
    backgroundColor: noBackground
      ? 'transparent'
      : `color-mix(in srgb, ${resolved} 10%, transparent)`,
    borderRadius: '50%',
    '& svg': { width: 20, height: 20 }
  };
});

export const StyledTooltipListItem = styled(ListItem)<ListItemProps>(() => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: 4,
  alignItems: 'start'
}));

export const StyledRenderTooltipListItem = styled(ListItem)<ListItemProps>(
  ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: theme.spacing(4),
    alignItems: 'start'
  })
);
